import { z } from 'zod';

import { AvailabilityTypeZod } from './availability-type';

import { DocumentZod } from 'types/zod/document';
import { DocumentStatusTypeZod } from 'types/zod/document-status-type';
import { DocumentTypeCodeZod } from 'types/zod/document-type-code';

export const ParticipantRoleZod = z.object({
    custom_message: z.string().optional(),
    document: DocumentZod.optional(),
    document_id: z.number(),
    document_name: z.string().optional(),
    document_status_code: DocumentStatusTypeZod.optional(),
    document_type_code: DocumentTypeCodeZod,
    group_mapping: z.string().optional(),
    notify: z.boolean().nullable().optional(),
    notifiable: z.boolean(),
    participant_id: z.number(),
    participant_role_id: z.number(),
    participant_role_status_code: z.string().optional(),
    role_type_code: z.literal('Observer').or(z.string()),
    visibility_code: AvailabilityTypeZod,
});
export type ParticipantRole = z.infer<typeof ParticipantRoleZod>;
